const initialState = {
  objectives: [],
  rootObjectives: [],
  loading: false,
  error: null,
};

export default initialState;
